export enum UserMutationTypes {
  SET_USER = "SET_USER",
  SET_EMAIL = "SET_EMAIL",
}
